export default "__VITE_ASSET__7dc060fa__"